import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "link";
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  className = "",
  variant = "primary",
  loading = false,
  disabled,
  ...props
}) => {
  const classes = [
    "auth-button",
    `auth-button--${variant}`,
    loading ? "is-loading" : "",
    disabled || loading ? "auth-is-disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {loading ? "Загружается..." : children}
    </button>
  );
};

export default Button;
